import { lazy } from "react";
export { PASS_TEST_PATH } from "./path";
export { ToPassTest } from "./to-pass-test";
export const PassTestPage = lazy(() => import("./page"));
